import { P2GButton } from '@parcel2go/core-ui';
import { P2GGrid } from '@parcel2go/core-ui';
import { P2GLink } from '@parcel2go/core-ui';
import { P2GLinkGroup } from '@parcel2go/core-ui';

import { QuoteTagType } from './utils/QuoteTagType';
import { useTranslation } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';

interface props {
  setQuoteTagType: (show: QuoteTagType) => void;
  quoteTagType: QuoteTagType;
  includeAll: () => void;
  excludeAll: () => void;
  setShowAll: () => void;
}

export const FilterAction: React.FC<props> = (props) => {
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);
  if (props.quoteTagType === 'Default') {
    return (
      <P2GLink onClick={() => props.setQuoteTagType('Unfiltered')}>
        {t('TOO_MANY_ACTION_OPTIONS_LINK', { defaultValue: 'Too many options?' })}
      </P2GLink>
    );
  }

  if (props.quoteTagType === 'Unfiltered') {
    return (
      <P2GGrid container alignContent="center" alignItems="center" spacing={2}>
        <P2GGrid item>
          <P2GLinkGroup
            links={[
              <P2GLink onClick={props.includeAll}>{t('SELECT_ALL_LINK', { defaultValue: 'Select All' })}</P2GLink>,
              <P2GLink onClick={props.excludeAll}>{t('REMOVE_ALL_LINK', { defaultValue: 'Remove All' })}</P2GLink>
            ]}
          />
        </P2GGrid>
        <P2GGrid item>
          <P2GButton onClick={props.setShowAll}>{t('SAVE_BUTTON', { defaultValue: 'Save' })}</P2GButton>
        </P2GGrid>
      </P2GGrid>
    );
  }

  return null;
};
